/**
 *
 * Find and set the same min-height for all donation prompt content boxes.
 * This prevents the hero image from moving when there is different amounts of text for each price point.
 * Issue US-8
 *
 */
export function equalHeightsInit() {
    // Run initial height calculation
    calculateHeights();
    
    // Add window resize handler to recalculate heights
    window.addEventListener('resize', debounce(calculateHeights, 250));
}

function calculateHeights() {
    if (document.body.classList.contains('page-template-landing-page')) {
        var highestBoxHeight = 0;
        const boxes = document.querySelectorAll('.c-donation-prompt__content');
        
        boxes.forEach(function(box) {
            var contentHeight = box.getBoundingClientRect().height;
            if (contentHeight > highestBoxHeight) {
                highestBoxHeight = contentHeight;
            }
        });
        
        boxes.forEach(function(box) {
            box.style.minHeight = highestBoxHeight + 'px';
        });
    }
}

// Debounce helper function to prevent too many resize calculations
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}